<template>
  <v-data-table
    dense
    v-resize="onResize"
    id="time__table"
    fixed-header
    :items-per-page="-1" 
    :footer-props="{ itemsPerPageOptions: [-1] }"
    :headers="headers"
    height="25vh"
    :items="items"
    no-data-text="측정된 자료가 없습니다."
    class="table_content"
    item-key="entity_no"
    sort-by="entity_no"
    :search="search"
    single-select
    hide-default-footer
  >

    <template v-slot:item="{ item }">
      <tr v-if="!isMobile">
        <td class="table_line info_num">{{ entityNo(item.entity_no) }}</td>
        <td class="table_line cow" title="클릭 시 회차별 상세 정보 보기" @click="$emit('detailInfo', item.entity_no)">
          <v-icon size="24" color="black">
            mdi-file-document
          </v-icon>
        </td>
        
        <td class="table_line">{{ item.result.total_milking_cnt }}</td>
        <td class="table_line">{{ item.result.total_milking_wt }}</td>
        <td class="table_line">
          <span v-for="(par, i) in item.result.parities" :key="i">
            {{ par }}
          </span>
        </td>
        <td class="table_line">{{ item.result.milking_mtime_per_kg }}</td>

        <td class="table_line">{{ item.result.avg_mfat_rt }}</td>
        <td style="text-align: center;"  class="table_line">{{ item.result.avg_mprt_rt }}</td>

        <td class="table_line">{{ item.result.avg_temp }}</td>
        <td class="table_line">{{ item.result.avg_cond }}</td>
        <td class="table_line">{{ item.result.avg_scell }}</td>

      </tr>
      <tr v-else class="mobile_tr">
        <td class="mb_table">
            <div class="date mt-2">
              <div class="flex-title"> 개체식별번호</div>
              <div title="클릭 시 회차별 상세 정보 보기" @click="$emit('detailInfo', item.entity_no)">
                <v-icon size="24" color="white">
                  mdi-file-document
                </v-icon>
                {{ entityNo(item.entity_no) }}
              </div>
            </div>


            <div class="flex s-bt">
              <div class="flex-title">산차</div>
              <div v-for="(par, p) in item.result.parities" :key="p">
                {{ par}}
              </div>
              
              <div class="line-table"></div>
            </div>

            <div class="flex s-bt">
              <div class="flex-title">착유량</div>
              <div>
                {{ item.result.total_milking_wt }}
              </div>
              
              <!-- <div class="line-table"></div> -->
            </div>

            <div class="flex s-bt">
              <div class="flex-title">착유회차</div>
              <div>
                {{ item.result.total_milking_cnt  }}
              </div>
              
              <!-- <div class="line-table"></div> -->
            </div>

            <div class="flex s-bt">
              <div class="flex-title">착유시간(kg/분)</div>
              <div>
                {{ item.result.milking_mtime_per_kg   }}
              </div>
              
              <div class="line-table"></div>
            </div>

            <div class="flex s-bt">
              <div class="flex-title">전도도</div>
              <div>
                {{ item.result.avg_cond   }}
              </div>
              
              <!-- <div class="line-table"></div> -->
            </div>

            <div class="flex s-bt">
              <div class="flex-title">온도</div>
              <div>
                {{ item.result.avg_temp  }}
              </div>
              
              <!-- <div class="line-table"></div> -->
            </div>

            <div class="flex s-bt">
              <div class="flex-title">유지방</div>
              <div>
                {{ item.result.avg_mfat_rt }}
              </div>
              
              <!-- <div class="line-table"></div> -->
            </div>

            <div class="flex s-bt">
              <div class="flex-title">유단백</div>
              <div>
                {{ item.result.avg_mprt_rt }}
              </div>

              <!-- <div class="line-table"></div> -->
            </div>

            <div class="flex s-bt">
              <div class="flex-title">체세포수</div>
              <div>
                {{ item.result.avg_scell }}
              </div>

              <div class="line-table"></div>
            </div>

          </td>
     
        </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "CustomTable",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    sortBy: {
      type: String,
      default: "entity_no",
    },
    sortDesc: {
      type: Boolean,
      default: true,
    },
    search: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    entityNo(entity){
      if (!entity) return "";
      return entity.replace(/^(\d{3})(\d{5})(\d{3})(\d)$/, "$1 $2 $3 $4");
    },
    toggleSort(column) {
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = false;
      }
    },
    addCommas(num) {
      if (typeof num === "number") {
        return num.toLocaleString();
      }
      return num;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },

  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style scoped lang="scss">
@import '../../../style/table_mb.scss';

.table_line{
  font-size:15px !important;
  border-right:1px solid #cfcfcf !important;
  text-align: center;
}
.text-align{
  text-align: center;
}
::v-deep .v-data-table-header > tr > th > span{
  font-size:14px !important;
  vertical-align: middle !important;
  letter-spacing: -2px !important;
  word-break: keep-all;
}
::v-deep .v-data-table-header tr th{
  // font-size:1px !important;
  background-color: #73a9ff !important;
  text-align: center !important;
  vertical-align: middle !important;
}
.v-table td {
  text-align: center;
  vertical-align: middle;
}
.info_num{
  font-size:13px !important;
  letter-spacing: -1.75px !important;
  white-space: nowrap;
}
::v-deep .mdi-arrow-up {
  display: none;
  // font-size:px !important;
}
.cow{
  cursor: pointer;
}
</style>
